<template>
  <div class="row m-0 soha-job-boards-job-box align-items-center">
    <div class="col-1">
      <img
        :src="`/media/logos/job-boards/${jobBoardName}.png`"
        width="45"
      >
    </div>
    <div class="col-9">
      <div class="w-100 d-flex align-items-center">
        <span class="font-weight-bolder"> {{ job.jobTitle }} </span>
        <label
          class=""
          :class="[
            'soha-job-status-label',
            job.status == 1 ? 'enable' : 'disable',
          ]"
        >
          {{
            job.status == 1
              ? $t(`${I18nPrefix}ENABLE`)
              : $t(`${I18nPrefix}EXPIRE`)
          }}
        </label>
        <label
          v-if="connected"
          class="soha-job-connected-label"
        >
          {{ $t(`${I18nPrefix}CONNECTED`) }}
        </label>
      </div>
      <div class="row soha-job-info">
        <span class="col-6">
          {{ $t(`${I18nPrefix}JOB_CODE`) }}: {{ jobCode }}
        </span>
        <span class="col-6">
          {{ $t(`${I18nPrefix}USERNAME`) }}:
          {{ job.jobboardAccount.username }}
        </span>
      </div>
    </div>
    <div class="d-flex col-2 justify-content-between">
      <soha-button
        v-b-tooltip.hover="{ customClass: 'soha-tooltip-class' }"
        icon="eye"
        outline
        height="40"
        width="40"
        :title="$t(`${I18nPrefix}SHOW_IN`) + ' ' + jobBoardPName"
        @btn-click="showInJobBoard"
      />
      <soha-button
        :key="toggleBtnKey"
        :loading="toggleBtnLoading"
        icon="plus"
        :disabled="connected"
        height="40"
        width="40"
        @btn-click="toggleJobBinding"
      />
    </div>
  </div>
</template>

<script>
import "@/assets/css/components/job/job-job-board-jobs.css";
import ApiService from "@/core/services/api.service";
import UIMixin from "@/mixins/UIMixin";

export default {
  name: "JobBoardsJob",

  mixins: [UIMixin],

  props: {
    job: {},
    jobId: null,
  },

  data() {
    return {
      I18nPrefix: "COMPONENTS.JOB.JOB_JOB_BOARD_AD.",
      jobBoards: [
        {
          name: "eestekhtam",
          id: "1",
          pName: "ای‌استخدام",
          url: "https://emp.e-estekhdam.com/hr/pipelines/",
        },
        {
          name: "jobvision",
          id: "3",
          pName: "جاب ویژن",
          url: "https://employer.jobvision.ir/jobs/",
        },
        {
          name: "jobinja",
          id: "4",
          pName: "جابینجا",
          url: "https://panel.jobinja.ir/",
        },
      ],
      toggleBtnLoading: false,
      toggleBtnKey: 0,
    };
  },

  computed: {
    jobBoardName() {
      return this.jobBoards.find((jobBoard) => {
        return jobBoard.id == this.job.jobboardAccount.jobboardId;
      }).name;
    },

    jobBoardPName() {
      return this.jobBoards.find((jobBoard) => {
        return jobBoard.id == this.job.jobboardAccount.jobboardId;
      }).pName;
    },

    connected() {
      return this.job.jobId == this.jobId;
    },

    jobCode() {
      if (this.job.code.includes("/")) {
        let lastIndex = this.job.code.lastIndexOf("/");
        return this.job.code.substring(lastIndex + 1);
      }
      return this.job.code;
    },
  },

  methods: {
    toggleJobBinding() {
      this.toggleBtnLoading = true;
      ApiService.post(`api/v2/jobs/jobBindings/${this.job.id}/toggle`, {
        jobId: this.connected ? null : this.jobId,
      }).then((data) => {
        if (data.data.code == 204) {
          this.successToast(data.data.message);
          this.job.jobId = this.connected ? null : this.jobId;
          this.toggleBtnKey++;
        } else {
          this.errorToast(data.data.message);
        }
        this.toggleBtnLoading = false;
      });
    },

    showInJobBoard() {
      let baseUrl = this.jobBoards.find((jobBoard) => {
        return jobBoard.id == this.job.jobboardAccount.jobboardId;
      }).url;
      let url = baseUrl + this.job.code;
      if (this.job.jobboardAccount.jobboardId == 3) url = url + "/applications";
      window.open(url, "_blank");
    },
  },
};
</script>
